import { useI18nStore } from './i18n.store';

export const useLanguage = () => {
  return useI18nStore((s) => s.language);
};

export const getLanguage = () => {
  return useI18nStore.getState().language;
};
